	<template>
		<div v-if="loading">
		<b-overlay :show="loading" no-wrap />
		</div>
		<div v-else>
		<div class="mb-3">
			<h5>Select the services to be available for the rate plan</h5>
		</div>
		<div v-for="service in availableServiceTypes" :key="service.id">
			<b-form-checkbox v-model="selectedServiceTypes" :value="service.id">[{{ service.id }}] {{ service.name }} <small class="text-muted">({{service.serviceTypeCategory.code }})</small></b-form-checkbox>
			<hr>
		</div>
		<div class="text-right mr-2">
			<b-button variant="primary" size="lg" @click="saveServiceTypes"> <md-icon icon="save"></md-icon>Save</b-button>
		</div>
		</div>
	</template>

	<script>
	export default {
	name: 'ServiceTypesManager',
	props: {
		ratePlanId: {
		type: Number,
		required: true
		},
		initialSelectedServiceTypes: {
		type: Array,
		required: true
		}
	},
	data() {
		return {
		loading: false,
		availableServiceTypes: [],
		selectedServiceTypes: [...this.initialSelectedServiceTypes]
		};
	},
	mounted() {
		// Fetch available service types based on ratePlanId
		this.fetchAvailableServiceTypes();
	},
	methods: {
		async fetchAvailableServiceTypes() {
			this.loading = true;
			try {
				// Simulate API call to fetch available service types
				// Replace with actual API call
				await this.$root.api.get(`/crud/service-types`,{params:{limit:50}})
				.then((res) => {
					this.availableServiceTypes = res.data.rows;
				})
				.catch(this.$root.handleRequestError)
				.finally(()=>this.loading=false)
			} catch (error) {
				console.error('Error fetching service types:', error);
			} finally {
				this.loading = false;
			}
		},
		saveServiceTypes() {
			this.loading=true;
			this.$root.api.put(`/rate-plans/${this.ratePlanId}/service-types`, {serviceTypes:[...this.selectedServiceTypes]})
			.then(() => {
				this.$root.showAlert(this.$t("global.doneSuccessfully"))
				this.$emit("done");
			})
			.catch(this.$root.handleRequestError)
			.finally(()=>{
				this.loading = false;
			})
		}
	}
	};
	</script>
